module.exports = __webpack_public_path__ + "img/img14.6ae3b81c.png";